/**
 * CSS compartilhado de campo de formulário (`label`/`input`/`select`/
 * `textarea`) — extraído porque o MESMO bloco de estilo estava
 * duplicado quase palavra-por-palavra em ~20 arquivos (todo modal de
 * criação/edição do ERP, mais os filtros de algumas listagens). Cada
 * tela continua dona do seu próprio HTML/lógica de campo (nenhum
 * conhecimento de domínio migrou para cá) — só o CSS repetido foi
 * centralizado, seguindo a mesma regra de "componente novo precisa de
 * reuso real" (`CODING_STANDARDS.md`, seção 16), aqui aplicada a um
 * bloco de estilo em vez de um Custom Element porque os campos vivem
 * como DOM leve dentro do Shadow Root de cada tela (não encapsulados
 * atrás de um componente próprio).
 *
 * Uso: interpolar `${FORM_FIELD_CSS}` dentro do `<style>` de qualquer
 * componente que renderize campos de formulário. Uma tela pode
 * adicionar regras extras (`.rodape`, campos específicos) depois desta
 * interpolação sem conflito.
 */
export const FORM_FIELD_CSS = `
  label {
    display: flex;
    flex-direction: column;
    gap: var(--pg-space-2, 8px);
    font-size: var(--pg-font-size-sm, 0.875rem);
    color: var(--pg-color-texto-secundario, #9aa1ab);
  }
  input, select, textarea {
    background: var(--pg-color-bg-base, #121417);
    border: var(--pg-border-largura, 1px) solid var(--pg-color-borda, #2a2f36);
    border-radius: var(--pg-radius-md, 10px);
    color: var(--pg-color-texto-primario, #f2f3f5);
    padding: var(--pg-space-3, 12px);
    font-size: var(--pg-font-size-sm, 0.875rem);
    font-family: inherit;
    transition: border-color 0.15s ease, box-shadow 0.15s ease;
  }
  input:disabled, select:disabled, textarea:disabled { opacity: 0.65; cursor: not-allowed; }
  input:hover:not(:disabled), select:hover:not(:disabled), textarea:hover:not(:disabled) {
    border-color: var(--pg-color-texto-desabilitado, #5c626b);
  }
  input:focus-visible, select:focus-visible, textarea:focus-visible {
    outline: none;
    border-color: var(--pg-color-destaque, #2f8cff);
    box-shadow: var(--pg-shadow-foco, 0 0 0 3px rgba(47,140,255,0.35));
  }
  .dica { font-size: var(--pg-font-size-xs, 0.75rem); color: var(--pg-color-texto-desabilitado, #5c626b); }
  .erro { font-size: var(--pg-font-size-xs, 0.75rem); color: var(--pg-color-erro, #e5484d); }
  .erro:empty { display: none; }
`;
